<template>

</template>

<script>
import oidc from "@/oidc";
import {GhtkAuth} from "gmjs";

export default {
  name: "SignOut",
  async mounted() {
    const ghtkAuth = new GhtkAuth(oidc)
    try {
      await ghtkAuth.signOut({
        revokeAccessToken: true,
        postLogoutRedirectUri: `${oidc.authnUrl}/sign-out?continue=${encodeURIComponent(window.location.origin)}`
      })
      localStorage.removeItem("permissions");
    } catch (e) {
      window.location = `${oidc.authnUrl}/sign-out?continue=${encodeURIComponent(window.location.origin)}`
    }

  }
}
</script>

<style scoped>

</style>